var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('v-banner',{attrs:{"img":_vm.bannerImg,"text":_vm.bannerText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }